import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';

import socket from '../../socket/socket';

export default function* getProtectedResponse<T>(eventName: ProtectedServerPlaceEvent, token: string, eventParam: object): IterableIterator<Promise<T>> {
  return yield new Promise<T>((resolve) => socket.emit(eventName, token, eventParam, resolve));
}
